import script from "./Netherlands.vue?vue&type=script&setup=true&lang=js"
export * from "./Netherlands.vue?vue&type=script&setup=true&lang=js"

import "./Netherlands.vue?vue&type=style&index=0&id=6bf81221&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bf81221"]])

export default __exports__